// extracted by mini-css-extract-plugin
export var settingsList = "_3a-0";
export var settingsRow = "_3a-1";
export var warningDot = "_3a-2";